import React from 'react';
import {Link} from "react-router-dom";

import styles from './ReturnToLoginPage.module.scss';
import arrowBack from '../../../constants/images/arrow-left.svg';
import {MAIN_ROUTES} from "../../../routing/main_routes";
import {linkStylesToLoginPage} from "../../../constants/linkStyles";

const ReturnToLoginPage = () => {
    return (
        <div className={styles.returnToLoginPage}>
            <img src={arrowBack} alt="arrow back icon"/>
            <p><Link to={MAIN_ROUTES.LOGIN} style={linkStylesToLoginPage}>Повернутись до входу</Link></p>
        </div>
    );
};

export default ReturnToLoginPage;